namespace TabAurous.Sales {
    export interface ApprovalOutReturnItemsRow {
        TransItemId?: number;
        TransId?: number;
        VoucherTypeId?: number;
        VoucherDate?: string;
        RefVoucherId?: number;
        DepartmentId?: number;
        PartyId?: number;
        Line_No?: number;
        BagNo?: string;
        SKU?: string;
        LotNo?: string;
        CertificateNo?: string;
        Hallmark?: number;
        RefNo?: string;
        ItemTypeId?: number;
        ProductId?: number;
        AttributeId?: number;
        Studded?: number;
        Pieces?: number;
        Weight?: number;
        Parts?: number;
        NetWeight?: number;
        DiamondPieces?: number;
        DiamondWeight?: number;
        StonePieces?: number;
        StoneWeight?: number;
        OtherPieces?: number;
        OtherWeight?: number;
        MetalAmount?: number;
        DiamondAmount?: number;
        StoneAmount?: number;
        OtherAmount?: number;
        CalcOnId?: number;
        DesignId?: number;
        DesignCode?: string;
        UnitRate?: number;
        UnitLabour?: number;
        UnitCost?: number;
        NetAmount?: number;
        Discount?: number;
        DiscountPer?: number;
        Status?: string;
        FancyCharges?: number;
        OtherCharges?: number;
        GrossAmount?: number;
        RefTransItemId?: number;
        RefTransId?: number;
        ImageName?: string;
        Remark?: string;
        SpecialRemark?: string;
        UserDescription?: string;
        AckStatus?: number;
        StockAllocation?: boolean;
        DeliveryDate?: string;
        CompanyId?: number;
        BagStatus?: string;
        WstPer?: number;
        WstWt?: number;
        Purity?: number;
        PureWeight?: number;
        ServerDate?: string;
        Remarks?: string;
        IsDisabled?: boolean;
        CCNetAmount?: number;
        CCGrossAmount?: number;
        LedgerName?: string;
        DeptName?: string;
        ProductCode?: string;
        ProductName?: string;
        CostMethodId?: Common.CostMethod;
        SalesCostMethodId?: Common.CostMethod;
        PurchaseCostMethodId?: Common.CostMethod;
        TaxCode?: string;
        HSN?: string;
        MetalId?: number;
        HasBom?: boolean;
        BOMDetails?: ApprovalOutReturnBOMRow[];
        LaborDetails?: ApprovalOutReturnLaborRow[];
        ItemType?: string;
        ProductTypeId?: number;
        CategoryId?: number;
        SubCategoryId?: number;
        BrandId?: number;
        SuperTypeId?: number;
        SuperTypeCode?: string;
        CollectionId?: number;
        MetalColorId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        CategoryCode?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        ProductSizeCode?: string;
        StampCode?: string;
        Rate?: number;
        KaratId?: number;
        ProductSizeId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        Lab?: string;
        VoucherNo?: string;
        TransDate?: string;
        HUID?: string;
        StampId?: number;
        ExportPieces?: number;
        CompanyCode?: string;
        StoneRate?: number;
        OtherRate?: number;
        MFAmount?: number;
        MF?: number;
        IsPosted?: boolean;
    }

    export namespace ApprovalOutReturnItemsRow {
        export const idProperty = 'TransItemId';
        export const nameProperty = 'ProductName';
        export const localTextPrefix = 'Sales.ApprovalOutReturnItems';
        export const deletePermission = 'Sales:ApprovalReturn:Delete';
        export const insertPermission = 'Sales:ApprovalReturn:Add';
        export const readPermission = '*';
        export const updatePermission = 'Sales:ApprovalReturn:Edit';

        export declare const enum Fields {
            TransItemId = "TransItemId",
            TransId = "TransId",
            VoucherTypeId = "VoucherTypeId",
            VoucherDate = "VoucherDate",
            RefVoucherId = "RefVoucherId",
            DepartmentId = "DepartmentId",
            PartyId = "PartyId",
            Line_No = "Line_No",
            BagNo = "BagNo",
            SKU = "SKU",
            LotNo = "LotNo",
            CertificateNo = "CertificateNo",
            Hallmark = "Hallmark",
            RefNo = "RefNo",
            ItemTypeId = "ItemTypeId",
            ProductId = "ProductId",
            AttributeId = "AttributeId",
            Studded = "Studded",
            Pieces = "Pieces",
            Weight = "Weight",
            Parts = "Parts",
            NetWeight = "NetWeight",
            DiamondPieces = "DiamondPieces",
            DiamondWeight = "DiamondWeight",
            StonePieces = "StonePieces",
            StoneWeight = "StoneWeight",
            OtherPieces = "OtherPieces",
            OtherWeight = "OtherWeight",
            MetalAmount = "MetalAmount",
            DiamondAmount = "DiamondAmount",
            StoneAmount = "StoneAmount",
            OtherAmount = "OtherAmount",
            CalcOnId = "CalcOnId",
            DesignId = "DesignId",
            DesignCode = "DesignCode",
            UnitRate = "UnitRate",
            UnitLabour = "UnitLabour",
            UnitCost = "UnitCost",
            NetAmount = "NetAmount",
            Discount = "Discount",
            DiscountPer = "DiscountPer",
            Status = "Status",
            FancyCharges = "FancyCharges",
            OtherCharges = "OtherCharges",
            GrossAmount = "GrossAmount",
            RefTransItemId = "RefTransItemId",
            RefTransId = "RefTransId",
            ImageName = "ImageName",
            Remark = "Remark",
            SpecialRemark = "SpecialRemark",
            UserDescription = "UserDescription",
            AckStatus = "AckStatus",
            StockAllocation = "StockAllocation",
            DeliveryDate = "DeliveryDate",
            CompanyId = "CompanyId",
            BagStatus = "BagStatus",
            WstPer = "WstPer",
            WstWt = "WstWt",
            Purity = "Purity",
            PureWeight = "PureWeight",
            ServerDate = "ServerDate",
            Remarks = "Remarks",
            IsDisabled = "IsDisabled",
            CCNetAmount = "CCNetAmount",
            CCGrossAmount = "CCGrossAmount",
            LedgerName = "LedgerName",
            DeptName = "DeptName",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            CostMethodId = "CostMethodId",
            SalesCostMethodId = "SalesCostMethodId",
            PurchaseCostMethodId = "PurchaseCostMethodId",
            TaxCode = "TaxCode",
            HSN = "HSN",
            MetalId = "MetalId",
            HasBom = "HasBom",
            BOMDetails = "BOMDetails",
            LaborDetails = "LaborDetails",
            ItemType = "ItemType",
            ProductTypeId = "ProductTypeId",
            CategoryId = "CategoryId",
            SubCategoryId = "SubCategoryId",
            BrandId = "BrandId",
            SuperTypeId = "SuperTypeId",
            SuperTypeCode = "SuperTypeCode",
            CollectionId = "CollectionId",
            MetalColorId = "MetalColorId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            CategoryCode = "CategoryCode",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            ProductSizeCode = "ProductSizeCode",
            StampCode = "StampCode",
            Rate = "Rate",
            KaratId = "KaratId",
            ProductSizeId = "ProductSizeId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            Lab = "Lab",
            VoucherNo = "VoucherNo",
            TransDate = "TransDate",
            HUID = "HUID",
            StampId = "StampId",
            ExportPieces = "ExportPieces",
            CompanyCode = "CompanyCode",
            StoneRate = "StoneRate",
            OtherRate = "OtherRate",
            MFAmount = "MFAmount",
            MF = "MF",
            IsPosted = "IsPosted"
        }
    }
}
